import { useMemo } from "react";
import { number, object } from "prop-types";
import { observer } from "mobx-react";
import { TimelineWorkTypeChart } from "./components/TimelineWorkTypeChart";
import { TimelineSectionChartContainer } from "./components/TimelineSectionChartContainer";
import { useEstimateEditorSettings } from "@tools";

export const TimelineSectionChart = observer(({ index, section }) => {
  const { allowEdition } = useEstimateEditorSettings();

  const { visibleWorkTypes } = section;

  const expandable = useMemo(() => (
    allowEdition || visibleWorkTypes.length > 0
  ), [ allowEdition, visibleWorkTypes.length ]);

  return (
    <TimelineSectionChartContainer
      element={section}
      index={index}
      height="large"
      type="section"
      expandable={expandable}
      expandOnContainerClick
    >
      {
        visibleWorkTypes.map((workType, index) => (
          <TimelineWorkTypeChart
            key={workType.id}
            index={index}
            section={section}
            workType={workType}
            blocksStartDate={section.startDay}
          />
        ))
      }
    </TimelineSectionChartContainer>
  );
});

TimelineSectionChart.propTypes = {
  section: object.isRequired,
  index: number.isRequired,
};
